import { Auth, CustomAxiosType, User } from "../types/types";
import authStorage from "../utils/authStorage";
import { client } from "./client";

const b6t = `NB6T`;

const useAuth = () => {
  const login = async ({ id, pw }: { id: string; pw: string }) => {
    const response = await client.post<CustomAxiosType<User>>(
      `/api/login` + b6t,
      {
        id,
        pw,
      }
    );
    return response.data.result;
  };

  const getRefreshToken = async () => {
    const token = authStorage.get();
    const response = await client.post<CustomAxiosType<Auth>>(
      `/api/refresh` + b6t,
      {
        accessToken: token?.accessToken,
        refreshToken: token?.refreshToken,
      }
    );
    return response.data.result;
  };

  return { login, getRefreshToken };
};

export default useAuth;
